export default {
  headerImgList: [
    {
      id: 0,
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/Hu3JNQDseLnkA5DJ.png",
      isSelect: false,
      path: "/notice-center/all-logs",
    },
    {
      id: 1,
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/SUxp22k0uYG9yPvP.png",
      isSelect: false,
      path: "/notice-center/problem-list",
    },
    {
      id: 2,
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/WT0olwVTRSQKDL1G.png",
      isSelect: false,
      showNum: true,
      path: "/notice-center/notice-list",
      value: "notice_num",
    },
  ],
  headerImgList1: [
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/Hu3JNQDseLnkA5DJ.png",
    },
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/SUxp22k0uYG9yPvP.png",
    },
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/WT0olwVTRSQKDL1G.png",
    },
  ],
  headerImgList2: [
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/UPdsEygi0oGdgTMY.png",
    },
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/vepL3sGw7TrzkQ0g.png",
    },
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/LPa9F44NEuTugvPP.png",
    },
  ],
  headerImgList3: [
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/kmmceJ5pYoq5GwQv.png",
    },
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/xbvB03PbiSzp0ziQ.png",
    },
    {
      img: "https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20230907/MWBpwn7gcTdI1h3m.png",
    },
  ],
  isShowBtnList: [11, 12, 13, 14], //  11=企业信息查询 ，12=门店信息查询，13=品牌店信息查询 , 14=内容服务商信息查询
  verifyTypeList: [
    {
      value: "0",
      label: "待审核",
      color: "#F67526",
    },
    {
      value: "1",
      label: "审核通过",
      color: "#0D9C00",
    },
    {
      value: "2",
      label: "审核未通过",
      color: "#D60431",
    },
  ],
  startTypeList: [
    {
      value: 0,
      label: "禁用",
    },
    {
      value: 1,
      label: "启动",
    },
  ],
  week_day: [
    {
      day_id: "1",
      day_name: "周一",
    },
    {
      day_id: "2",
      day_name: "周二",
    },
    {
      day_id: "3",
      day_name: "周三",
    },
    {
      day_id: "4",
      day_name: "周四",
    },
    {
      day_id: "5",
      day_name: "周五",
    },
    {
      day_id: "6",
      day_name: "周六",
    },
    {
      day_id: "7",
      day_name: "周日",
    },
  ],
  applyStatus: [
    {
      value: 0,
      label: "审核中",
    },
    {
      value: 1,
      label: "待签约",
    },
    {
      value: 2,
      label: "审核驳回",
    },
    {
      value: 3,
      label: "开通成功",
    },
  ],
};

